module.exports = __webpack_public_path__ + "static/img/bonus_7.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_7.png
// module id = 4xCX
// module chunks = 0